import { Servidor } from "@/contexts/cadastro/servidor/model/Servidor";
import { api } from "@/shared/api/api";

export const createServidorApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<Servidor[]>("/servidores/todos", {
      headers,
    });
    return data;
  };

  return { listAll };
};
